
export const extractIds = (data: any): number[] => {
    if (!Array.isArray(data)) return [];

    return data
        .map(item => {

            if (typeof item === "object" && item !== null) {
                return Number(item.id);
            }

            return Number(item);
        })

        .filter(id => !isNaN(id))

        .sort((a, b) => a - b);
};